module.exports = __webpack_public_path__ + "img/12_of_Hearts.svg.69fd9a18.png";